<template>
  <popup
    ref="popup"
    :show="show"
    :title="''"
    :footer="false"
    class="indicator-desc-popup"
    @close="close"
  >
    <h3 class="desc-header">
      {{ $t('Gattaran_visit_uIke_aoLu' /** Indicator Description */) }}
    </h3>
    <div class="desc-body">
      <h3 v-if="data.name" class="desc-title">{{ data.name }}</h3>
      <div v-if="data.desc" class="desc-content">
        <div v-for="(line, index) in descContent" :key="index" class="desc-line">
          {{ line }}
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import popup from '@/components-new/popup/index.vue'

export default {
  components: {
    popup,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    descContent() {
      if (!this.data.desc) return []
      return this.data.desc.split('\n') || []
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
/* 关闭按钮置右：popup 默认在左，通过 order 调整 */
.indicator-desc-popup ::v-deep .content-header {
  .icon-outline_close {
    order: 2;
  }
  span {
    order: 0;
  }
  i:last-of-type {
    order: 1;
  }
}
.desc-header {
  font-family: DiDi Sans Pro;
  font-size: 36px;
  font-weight: bold;
  line-height: 44px;
  margin-bottom: 32px;
}
.desc-body {
  padding: 32px;
  border-radius: 24px;
  background: rgba(242, 242, 245, 0.5);
  display: flex;
  flex-direction: column;
  gap: 20px; /* 标题与说明间距 */
  padding-bottom: 40px;
}
.desc-title {
  font-family: DiDi Sans Pro;
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: 0px;
  color: #0c0c0d;
  margin: 0;
  padding: 0;
}
.desc-content {
  font-family: DiDi Sans Pro;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0em;
  color: #0c0c0d;
  word-break: break-word;
}
.desc-line {
  position: relative;
  padding-left: 24px;
}
.desc-line::before {
  content: '•';
  position: absolute;
  left: 2px;
  top: 0;
  font-size: 24px;
}
</style>
